export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/train/front/booking',
      name: 'distributor-train-front-booking',
      component: () => import('./index.vue'),
    },
  ]
};
